import { createRouter as createTanStackRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import { getContext } from "./integrations/tanstack-query/root-provider";
import { routeTree } from "./routeTree.gen";

export function getRouter() {
  const context = getContext();

  const router = createTanStackRouter({
    routeTree,
    context,
    scrollRestoration: true,
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
  });

  // Needs `@tanstack/react-router-ssr-query` 1.167.2 or later (it brings
  // `router-ssr-query-core` 1.169.2). Under 1.167.1 every page logged
  // "Error reading query stream: TypeError: Cannot read properties of undefined
  // (reading 'mutations')" on load, in production and in dev.
  //
  // The integration streams queries that settle after the HTML is sent, and the
  // client reads that stream. 1.169.1's reader passed every chunk to
  // `hydrate()` BEFORE checking `done`, so the last read, `{ done: true, value:
  // undefined }`, became `hydrate(queryClient, undefined)`. That used to be
  // harmless because query-core's `hydrate` returned early on a non-object
  // (5.102.0 still does). The query-core pinned here, 5.102.2, has no such
  // check and reads `dehydratedState.mutations` straight away. Nothing on this site runs a
  // query, so the stream always closes empty and every page hit the bad read.
  // 1.169.2 checks `done` first.
  //
  // Bump these two packages together. The integration's peer range is the only
  // place that says which query-core it was written for.
  setupRouterSsrQueryIntegration({ router, queryClient: context.queryClient });

  return router;
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
